module.exports = __webpack_public_path__ + "static/typography-mix-typefaces-do-86d34783130347964e279c3248fb4135.png";